import script from "./memberCard.vue?vue&type=script&setup=true&lang=js"
export * from "./memberCard.vue?vue&type=script&setup=true&lang=js"

import "./memberCard.vue?vue&type=style&index=0&id=3ee883a9&lang=scss"

const __exports__ = script;

export default __exports__